module.exports = __webpack_public_path__ + "img/Platforms-action.6474507d.svg";